import React from 'react';

import Button from 'components/shared/Buttons/Button';

const Footer = ({ handleClose }) => (
  <div className="flex w-full items-center justify-between gap-4">
    <Button text="Cancel" onClick={handleClose} outlined color="neutral" size="small" />
    <div id="footer-actions"></div>
  </div>
);

export default Footer;
